import { jsx as _jsx } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
import { Legend as RechartsLegend } from 'recharts';
const Legend = (props) => {
    const { verticalAlign, wrapperStyle } = props;
    return (_jsx(RechartsLegend
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    , Object.assign({ 
        // biome-ignore lint/suspicious/noExplicitAny: <explanation>
        formatter: props.formatter, wrapperStyle: verticalAlign === 'bottom' ? { bottom: 0 } : wrapperStyle }, props)));
};
Legend.defaultProps = {
    iconType: 'circle',
    iconSize: 12,
    layout: 'vertical',
    align: 'right',
    verticalAlign: 'top',
};
export default Legend;
